import { WalletRefund, WalletRefundStatus } from '@/model/WalletRefund';
import { walletRefundsService } from '@services/wallet-refunds.service';
import { Options, Vue } from 'vue-class-component';
import { Model } from 'vue-property-decorator';

interface RefundFormData {
  status: WalletRefundStatus;
  admin_notes: string;
}

@Options({
  emits: ['update:visible', 'saved'],
})
export default class RefundDialog extends Vue {
  @Model('visible')
  readonly showModel!: boolean;

  @Model('refund')
  readonly refundModel!: WalletRefund;

  formData: RefundFormData = {
    status: WalletRefundStatus.REFUNDED,
    admin_notes: '',
  };

  isLoading = false;

  get statusOptions() {
    return [
      { label: 'Rimborsato', value: WalletRefundStatus.REFUNDED },
      { label: 'Rifiutato', value: WalletRefundStatus.REJECTED },
    ];
  }

  onShow() {
    // Inizializza il form con i dati del refund
    this.formData = {
      status: WalletRefundStatus.REFUNDED, // default
      admin_notes: this.refundModel?.admin_notes || '',
    };
  }

  onHide() {
    // Reset form
    this.formData = {
      status: WalletRefundStatus.REFUNDED,
      admin_notes: '',
    };
  }

  onCancel() {
    this.$emit('update:visible', false);
  }

  async onSubmit() {
    if (!this.refundModel?.id) {
      this.$errorMessage('ID rimborso non valido');
      return;
    }

    try {
      this.isLoading = true;

      await walletRefundsService.updatePatch({
        id: this.refundModel.id,
        status: this.formData.status,
        admin_notes: this.formData.admin_notes,
      });

      this.$successMessage('Rimborso aggiornato con successo');
      this.$emit('saved');
      this.$emit('update:visible', false);
    } catch (error) {
      console.error('Error updating refund:', error);
      this.$errorMessage('Errore durante l\'aggiornamento del rimborso');
    } finally {
      this.isLoading = false;
    }
  }
}
